var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnicorns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88041",
    "data-name": "Group 88041",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.786,
    height: 75.51,
    viewBox: "0 0 77.786 75.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25597",
    "data-name": "Rectangle 25597",
    width: 77.786,
    height: 75.51,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88040",
    "data-name": "Group 88040",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308463",
    "data-name": "Path 308463",
    d: "M5.445,41.354c-3.628-9.6,6.978-14.09,6.978-14.09-.56-11.79,11.129-12.632,11.129-12.632C25.368,10.225,28.1,7.964,30.8,6.859a12.168,12.168,0,0,1,11.36,1.214A42.539,42.539,0,0,0,51.71,12.9L35.074,31.944A101.96,101.96,0,0,0,16.981,60.811,9.632,9.632,0,0,1,5.931,67.1s2.626-6.714-1.923-11.791a10.185,10.185,0,0,1-2.455-3.89C.8,48.768.816,44.812,5.445,41.354Z",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308464",
    "data-name": "Path 308464",
    d: "M9,55.671c-.947-.958-6.758-7.6.336-11.823-3.628-9.6,6.977-14.09,6.977-14.09-.559-11.79,11.13-12.633,11.13-12.633C29.263,12.719,32,10.458,34.7,9.352a12.171,12.171,0,0,1,11.36,1.215,43.82,43.82,0,0,0,5.107,2.957l.543-.622a42.486,42.486,0,0,1-9.545-4.828A12.172,12.172,0,0,0,30.8,6.859c-2.7,1.105-5.436,3.367-7.252,7.773,0,0-11.689.843-11.13,12.633,0,0-10.606,4.485-6.977,14.09C.791,44.831.8,48.811,1.565,51.46a8.217,8.217,0,0,0,2.08,3.463C8.692,60.039,5.931,67.1,5.931,67.1a10.3,10.3,0,0,0,4.522-.149C10.8,64.425,12.111,58.813,9,55.671",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308465",
    "data-name": "Path 308465",
    d: "M65.366,21.821l10.8-11.764a1.761,1.761,0,0,0-2.229-2.663l-13.433,8.62a3.844,3.844,0,1,0,4.861,5.807",
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308466",
    "data-name": "Path 308466",
    d: "M73.938,7.394l-1.009.648a1.706,1.706,0,0,1-.19,2.015l-10.8,11.764a3.828,3.828,0,0,1-1.228.966,3.845,3.845,0,0,0,4.656-.966l10.8-11.764a1.761,1.761,0,0,0-2.229-2.663",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308467",
    "data-name": "Path 308467",
    d: "M60.631,15.932a19.292,19.292,0,0,0-2.37-12.118L58.1,3.523s-6.333,2.384-7.523,8.93a26.561,26.561,0,0,0-26.693,19.83L12.9,74.264H51.611s5.517-10.6.092-18.432a11.691,11.691,0,0,1-1.721-3.621c-.841-3.148-1.309-8.746,2.737-15.283a11.562,11.562,0,0,0,11.463.96s7.585,7.319,11.184-1.831C78.094,29.118,60.631,15.932,60.631,15.932Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308468",
    "data-name": "Path 308468",
    d: "M60.631,15.932a19.292,19.292,0,0,0-2.37-12.118L58.1,3.523a13.106,13.106,0,0,0-3.109,1.845l1.379,3.987a15.448,15.448,0,0,1,.4,6.062l-.3,2.254,1.815,1.37a78.384,78.384,0,0,1,7.992,7.117c5.188,5.382,5.63,8.053,5.465,8.474-.2.5-.9,2.132-1.638,2.132a6.488,6.488,0,0,1-3.216-1.68L65.248,33.5a.622.622,0,0,0-.7-.113l-2.052.987a6.96,6.96,0,0,1-3.072.732,9.009,9.009,0,0,1-4.633-1.483L52,31.88a.624.624,0,0,0-.861.2l-1.732,2.8c-4.915,7.94-4.107,14.9-3.188,18.338A15.559,15.559,0,0,0,48.5,58.05c2.773,4,1.531,9.4.511,12.319l-1.344,3.895h3.943s5.517-10.6.092-18.432a11.68,11.68,0,0,1-1.721-3.621c-.841-3.148-1.309-8.746,2.737-15.283a11.562,11.562,0,0,0,11.463.96s7.585,7.32,11.183-1.831C78.094,29.118,60.631,15.932,60.631,15.932Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308469",
    "data-name": "Path 308469",
    d: "M47.32,29.939s0,4.739,5.4,6.988",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308470",
    "data-name": "Path 308470",
    d: "M23.391,63.84a1.266,1.266,0,0,1-1.207-1.562l.4-1.521a1.246,1.246,0,0,1,2.412.63l-.4,1.522A1.247,1.247,0,0,1,23.391,63.84Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308471",
    "data-name": "Path 308471",
    d: "M24.772,58.556a1.266,1.266,0,0,1-1.207-1.562l4.628-17.7a1.247,1.247,0,1,1,2.412.631L25.977,57.625A1.247,1.247,0,0,1,24.772,58.556Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308472",
    "data-name": "Path 308472",
    d: "M56.4,21.171a1.844,1.844,0,0,1,1.634,2,1.667,1.667,0,1,1-3.268,0,1.844,1.844,0,0,1,1.634-2",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308473",
    "data-name": "Path 308473",
    d: "M69.6,34.2a1.246,1.246,0,0,1-1.221-1,.566.566,0,0,0-.352-.419,1.246,1.246,0,0,1,.9-2.324,3.045,3.045,0,0,1,1.9,2.259A1.259,1.259,0,0,1,69.6,34.2",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308474",
    "data-name": "Path 308474",
    d: "M73.208,6.345l-11.223,7.2A21.08,21.08,0,0,0,59.121,2.9,1.248,1.248,0,0,0,57.6,2.356c-.265.1-6.084,2.361-7.952,8.421A42.012,42.012,0,0,1,42.8,7.039,13.368,13.368,0,0,0,30.276,5.706a14.347,14.347,0,0,0-7.642,7.78C15.9,14.554,11.085,19.567,11.1,26.5c-5.377,2.815-9.056,8.28-7.175,14.429-5,4.2-5.135,10.491-.9,15.215,3.966,4.427,1.784,10.262,1.691,10.5a1.258,1.258,0,0,0,.873,1.667,10.877,10.877,0,0,0,7.879-1.335l-1.822,6.973a1.258,1.258,0,0,0,1.206,1.562h38.7a1.246,1.246,0,0,0,1.106-.672c.24-.46,5.8-11.365.011-19.717-3.377-4.875-2.266-11.606.441-16.5a12.45,12.45,0,0,0,10.8.724c1.292,1.043,4.314,3.1,7.4,2.425,2.248-.489,3.986-2.259,5.166-5.26,1.326-3.372-.9-8.078-6.608-13.987-.61-.631-1.226-1.241-1.834-1.823l9-9.8C79.3,8.457,76.012,4.534,73.208,6.345ZM7.484,66.035c.571-2.461,1.081-7.445-2.6-11.559-3.581-4-3.07-8.892,1.254-12.122a1.247,1.247,0,0,0,.421-1.44c-3.155-8.35,5.911-12.336,6.3-12.5a1.246,1.246,0,0,0,.76-1.207c-.493-10.406,9.549-11.3,9.974-11.33a1.247,1.247,0,0,0,1.063-.769c1.45-3.518,3.661-5.905,6.571-7.094a10.881,10.881,0,0,1,10.193,1.1A45.307,45.307,0,0,0,45.4,11.5,27.791,27.791,0,0,0,22.617,31.967L14.641,62.481a8.074,8.074,0,0,1-7.157,3.554m63.295-26.7c-2.227.49-4.934-1.528-5.788-2.345a1.247,1.247,0,0,0-1.406-.226,10.336,10.336,0,0,1-10.26-.893c-2.257-1.422-4.763-2.882-4.815-5.94a1.247,1.247,0,0,0-2.493.008,9.1,9.1,0,0,0,4.9,7.519c-3.136,5.71-4.19,13.452-.289,19.083,4.181,6.036,1.171,14.118.138,16.476h-36.3L25.029,32.6a25.163,25.163,0,0,1,25.44-18.9,1.244,1.244,0,0,0,1.274-1.023A10.969,10.969,0,0,1,57.51,5.148a18.154,18.154,0,0,1,1.829,10.62,1.247,1.247,0,0,0,.485,1.159,81.341,81.341,0,0,1,8.264,7.351c4.818,4.99,6.971,9.011,6.061,11.323C73.294,37.776,72.16,39.033,70.779,39.336Zm-8.057-23.3,4.1-2.633a8.953,8.953,0,0,0,2.1,2.635L66.2,19.007c-1.369-1.232-2.6-2.257-3.479-2.97m12.449-6.8L70.614,14.2a6.448,6.448,0,0,1-1.679-2.151l5.593-3.589a.515.515,0,0,1,.643.777",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicorns);
export default __webpack_public_path__ + "static/media/Unicorns.2b0e0249d28d548a3e66323509782b59.svg";
export { ForwardRef as ReactComponent };